/**
 * 本地登录态。PC 后台的 token 只含 adminId，不含 tenantId。
 */

const KEY_TOKEN = 'admin_token'
const KEY_USERNAME = 'admin_username'

export function getToken() {
  return localStorage.getItem(KEY_TOKEN) || ''
}

export function saveSession({ token, username }) {
  localStorage.setItem(KEY_TOKEN, token)
  localStorage.setItem(KEY_USERNAME, username || '')
}

export function getUsername() {
  return localStorage.getItem(KEY_USERNAME) || ''
}

export function isLoggedIn() {
  return !!getToken()
}

export function clearToken() {
  localStorage.removeItem(KEY_TOKEN)
  localStorage.removeItem(KEY_USERNAME)
}
